import {buildStateEvent, GenericStateEvent} from '../../common-redux'
import {SupportTeam} from './model'

export interface SupportTeamStateEvent<T> extends GenericStateEvent<T> {}

export const GetAllSupportTeamWithPermissionSuccessEvent = {
    type: 'GetAllSupportTeamWithPermissionSuccessEvent',
    build: (payload: SupportTeam[]) => buildStateEvent(GetAllSupportTeamWithPermissionSuccessEvent.type, payload)
}
